import { render, staticRenderFns } from "./DeactivateInfo.vue?vue&type=template&id=803f4ac6&scoped=true"
import script from "./DeactivateInfo.vue?vue&type=script&lang=js"
export * from "./DeactivateInfo.vue?vue&type=script&lang=js"
import style0 from "./DeactivateInfo.vue?vue&type=style&index=0&id=803f4ac6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803f4ac6",
  null
  
)

export default component.exports